export const BANKS = [
  { id: "001", name: "BANCO DE BOGOTÁ", transfiya: false },
  { id: "002", name: "BANCO POPULAR", transfiya: true },
  { id: "006", name: "ITAÚ", transfiya: true },
  { id: "007", name: "BANCOLOMBIA", transfiya: true },
  { id: "009", name: "CITIBANK", transfiya: false },
  { id: "012", name: "BANCO GNB SUDAMERIS", transfiya: false },
  { id: "013", name: "BBVA COLOMBIA", transfiya: false },
  { id: "019", name: "SCOTIABANK COLPATRIA S.A.", transfiya: false },
  { id: "023", name: "BANCO DE OCCIDENTE", transfiya: false },
  { id: "031", name: "BANCOLDEX S.A.", transfiya: false },
  { id: "032", name: "BANCO CAJA SOCIAL BCSC S.A.", transfiya: false },
  { id: "040", name: "BANCO AGRARIO", transfiya: true },
  { id: "042", name: "BNP PARIBAS COLOMBIA", transfiya: false },
  { id: "047", name: "BANCO MUNDO MUJER", transfiya: false },
  { id: "051", name: "BANCO DAVIVIENDA S.A.", transfiya: true },
  { id: "052", name: "BANCO AV VILLAS", transfiya: false },
  { id: "053", name: "BANCO W S.A.", transfiya: false },
  { id: "058", name: "BANCO PROCREDIT COLOMBIA", transfiya: false },
  { id: "059", name: "BANCAMIA S.A.", transfiya: true },
  { id: "060", name: "BANCO PICHINCHA", transfiya: false },
  { id: "061", name: "BANCOOMEVA", transfiya: true },
  { id: "062", name: "BANCO FALABELLA S.A.", transfiya: true },
  { id: "063", name: "BANCO FINANDINA S.A.", transfiya: true },
  { id: "064", name: "BANCO MULTIBANK S.A.", transfiya: false },
  { id: "065", name: "BANCO SANTANDER DE NEGOCIOS COLOMBIA S.A.", transfiya: false },
  { id: "066", name: "BANCO COOPERATIVO COOPCENTRAL", transfiya: true },
  { id: "067", name: "BANCO COMPARTIR S.A.", transfiya: false },
  { id: "069", name: "BANCO SERFINANZA S.A.", transfiya: true },
  { id: "070", name: "LULO BANK", transfiya: false },
  { id: "071", name: "BANCO JP MORGAN COLOMBIA", transfiya: false },
  { id: "083", name: "COMPENSAR", transfiya: false },
  { id: "084", name: "APORTES EN LINEA", transfiya: false },
  { id: "086", name: "ASOPAGOS", transfiya: false },
  { id: "087", name: "FEDECAJAS", transfiya: false },
  { id: "088", name: "SIMPLE", transfiya: false },
  { id: "089", name: "ENLACE OPERATIVO", transfiya: false },
  { id: "090", name: "CORFICOLOMBIANA", transfiya: false },
  { id: "121", name: "FINANCIERA JURISCOOP S.A.", transfiya: false },
  { id: "283", name: "COOPERATIVA FINANCIERA DE ANTIOQUIA", transfiya: true },
  { id: "289", name: "COOTRAFA COOPERATIVA FINANCIERA", transfiya: false },
  { id: "292", name: "CONFIAR", transfiya: true },
  { id: "303", name: "Banco Unión (GIROS Y FINANZAS)", transfiya: false },
  { id: "342", name: "SERVIFINANSA S.A.", transfiya: false },
  { id: "370", name: "COLTEFINANCIERA S.A.", transfiya: false },
  { id: "507", name: "NEQUI", transfiya: true, isWallet: true },
  { id: "550", name: "DECEVAL", transfiya: false },
  { id: "551", name: "DAVIPLATA", transfiya: true, isWallet: true },
  { id: "560", name: "PIBANK", transfiya: false },
  { id: "637", name: "IRIS", transfiya: false },
  { id: "683", name: "DIRECCIÓN DEL TESORO NACIONAL", transfiya: false },
  { id: "685", name: "DGCPTN SISTEMA GENERAL DE REGALIAS", transfiya: false },
  { id: "801", name: "MOVII", transfiya: true },
  { id: "803", name: "POWWI", transfiya: true },
  { id: "805", name: "BANCO BTG PACTUAL", transfiya: false },
  { id: "808", name: "Bold CF", transfiya: true },
  { id: "812", name: "COINK", transfiya: false },
  { id: "809", name: "NU", transfiya: false },
  { id: "814", name: "Global66", transfiya: false },
  { id: "819", name: "Banco Contactar", transfiya: false },
  { id: "1053", name: "BANCO WWB", transfiya: false },
  { id: "1291", name: "COOFINEP", transfiya: false },
  { id: "1558", name: "Ban100 (CREDIFINANCIERA SA)", transfiya: false },
  { id: "1559", name: "DING TECNIPAGOS", transfiya: false },
  { id: "1560", name: "UALA", transfiya: false },
  { id: "1561", name: "RAPPIPAY", transfiya: false },
  { id: "820", name: "Superdigital", transfiya: false },
  { id: "821", name: "Banco Cooperativo Coopcentral Digital", transfiya: false },
  { id: "822", name: "Dale", transfiya: false },
  { id: "823", name: "Banco Crezcamos", transfiya: false }
];

export const ACCOUNT_TYPES = [
  { id: 1, label: "Cuenta Corriente" },
  { id: 2, label: "Cuenta de Ahorros" },
  { id: 3, label: "Efectivo", disabled: true },
  { id: 4, label: "Número de Celular" },
  { id: 5, label: "Bre-B", disabled: true },
];